import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleTryAgain = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ minHeight: '100vh', padding: '40px 20px', display: 'grid', placeItems: 'center', textAlign: 'center', background: '#f5f7f5', fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
          <div style={{ width: '100%', maxWidth: '460px', padding: '40px', borderRadius: '18px', background: '#fff', border: '1px solid #dce5df', boxShadow: '0 18px 45px rgba(15,45,32,0.08)' }}>
          <div style={{ width: '64px', height: '64px', margin: '0 auto 18px', borderRadius: '18px', background: '#fff1f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#122019', margin: '0 0 8px' }}>This screen could not be loaded</h2>
          <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#52645a', margin: '0 0 22px' }}>Your account and saved data are safe. Try rendering the screen again, or reload the page if the problem continues.</p>
          <button
            onClick={this.handleTryAgain}
            data-testid="error-boundary-reload"
            style={{
              minHeight: '44px', padding: '10px 24px', borderRadius: '10px', border: 'none', cursor: 'pointer',
              background: '#17603e', color: '#fff', fontSize: '14px', fontWeight: '700',
            }}
          >
            Try again
          </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
